import { Form, Input, Radio, Select } from 'antd';
import React from 'react';
import { IdefaultVendor } from './Vendor';

interface VendorProductDetailsCollapsibleProps {
  vendorDetails: IdefaultVendor;
  onChange: (key: string, value: any) => void;
}

type FieldType = {
  product_number?: string;
  directionality?: string;
  ip_rating?: string;
  software_version?: string;
  hardware_version?: string;
  firmware_version?: string;
  backhaul?: string;
};

const VendorProductDetailsCollapsible: React.FC<VendorProductDetailsCollapsibleProps> = ({ vendorDetails, onChange }) => {
  const handleChange = (key: string, value: any) => {
    onChange(key, value);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 24 }}
      initialValues={{
        product_number: vendorDetails.product_number,
        directionality: vendorDetails.directionality,
        ip_rating: vendorDetails.ip_rating,
        software_version: vendorDetails.software_version,
        hardware_version: vendorDetails.hardware_version,
        firmware_version: vendorDetails.firmware_version,
        backhaul: vendorDetails.backhaul,
      }}
      autoComplete="off">
      <Form.Item<FieldType> label="Product Number" name="product_number" rules={[{ required: false }]}>
        <Input onChange={(e) => handleChange('product_number', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Directionality" name="directionality" rules={[{ required: true, message: 'Please select directionality!' }]}>
        <Radio.Group
          value={vendorDetails.directionality}
          options={[
            { value: 'Directional', label: 'Directional' },
            { value: 'Omni', label: 'Omni' },
          ]}
          onChange={(e) => {
            handleChange('directionality', e.target.value);
          }}
        />
      </Form.Item>
      <Form.Item<FieldType> label="IP Rating" name="ip_rating" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          options={[]}
          onChange={(value) => handleChange('ip_rating', value)}
        />
      </Form.Item>
      <Form.Item<FieldType> label="Software Version" name="software_version" rules={[{ required: false }]}>
        <Input onChange={(e) => handleChange('software_version', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Hardware Version" name="hardware_version" rules={[{ required: false }]}>
        <Input onChange={(e) => handleChange('hardware_version', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Firmware Version" name="firmware_version" rules={[{ required: false }]}>
        <Input onChange={(e) => handleChange('firmware_version', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Backhaul" name="backhaul" rules={[{ required: false }]}>
        <Input onChange={(e) => handleChange('backhaul', e.target.value)} />
      </Form.Item>
    </Form>
  );
};

export default VendorProductDetailsCollapsible;
